export default Object.freeze({
  step1: 'MemberInformation',
  step2: 'ContactInformation',
  step3: 'PrivacyAndAccess',
  step4: 'EligibilityInformation',
  step5: 'StudentDeclaration',
  step6: 'VeteranCardInformation',
  step7: 'ConcessionDeclaration',
  step8: 'ReviewAndSubmit',
});
